export enum PeopleFetchEnum {
  connected = 'connected',
  notConnected = 'notConnected',
  matching = 'matching',
  notMatching = 'notMatching'
}
